import React, {useState, useEffect} from "react";
import { Pagination } from "antd";

import config from "appConfig";

import AdList from "../AdList";
import getWidthContext from "../../HOCs/getWidthContext";
import {
  checkEmptyObject,
  scrollToTop,
  isMobileScreen,
  calculateTotalPagingCount
} from "../../services";
import styles from "./paginationAds.scss";
import AdsSectionLoader from "../../containers/SearchPage/AdsSectionLoader";

function PaginationAds({
  ads,
  handlePageChange,
  adCardProps,
  responsiveProps,
  gutter,
  AdCardComponent,
  emptyAdsText,
  width,
  paginationClassName,
  category,
  module,
  bottomSection,
  showGoogleAds,
}) {
  const handlePageNumberChange = (page: any, pageSize: any) => {
    handlePageChange(page, pageSize);
    scrollToTop();
  };
  const [smallStyle, setSmallStyle] = useState("");

  useEffect(() => {
    if(checkEmptyObject(ads)){
      //set mini pagionation style if total number of pages are between 7 and 9
      (ads.count > config.maxAdPerPage * 7 && ads.count <= config.maxAdPerPage * 9 && isMobile) 
        ? setSmallStyle("small") : setSmallStyle("");
    }
  }, [ads]);


  const isMobile = isMobileScreen(width);
  return checkEmptyObject(ads) ? (
    <React.Fragment>
      <AdList
        ads={ads.data}
        responsiveProps={responsiveProps}
        adCardProps={{ ...adCardProps, isMobile }}
        gutter={gutter}
        AdCardComponent={AdCardComponent}
        emptyAdsText={emptyAdsText}
        className={styles.adList}
        showGoogleAds={showGoogleAds}
        category={category}
        module={module}
        showDetails={true}
        bottomSection={bottomSection}
      />

      {ads.count > config.maxAdPerPage ? (
        <Pagination
          total={calculateTotalPagingCount(ads.count, ads.page)}
          current={ads.page}
          pageSize={config.maxAdPerPage}
          onChange={handlePageNumberChange}
          size={smallStyle}
          className={`${styles.pagination} ${paginationClassName}`}
        />
      ) : null}
    </React.Fragment>
  ) : (
      // shadow Loader of the ads
        <AdsSectionLoader />
  );
}


PaginationAds.defaultProps = {
  adCardProps: {},
  ads: {},
  responsiveProps: {},
  gutter: 0,
  emptyAdsText: undefined,
  paginationClassName: "",
  showGoogleAds: true
};

export default getWidthContext(PaginationAds);



// WEBPACK FOOTER //
// ./src/components/PaginationAds/index.tsx